require('./rightsSelectorView.scss');

// @ vendor
const React = require('react');
const PropTypes = require('prop-types');
const { connect } = require('react-redux');
const { bindActionCreators } = require('redux');
const { formatText, getFinalTitle, FormattedText } = require('core/i18n').i18n;
const moment = require('moment');
const lodash = require('lodash');

// @ commons
const { OKCover } = require('commonsComponents/OKCover');
const { OKHeaderSubPage } = require('commonsComponents/OKHeaderSubPage');
const { OKSectionBox } = require('commonsComponents/OKSectionBox');
const { OKLink } = require('commonsComponents/OKLink');

// @components
const ContactInfoBox = require('components/myProfile/contactInfoBox/contactInfoBox');
const { OKTable } = require('commonsComponents/OKTable');
const { OKTableRow } = require('commonsComponents/OKTableRow');
const { OKTableCell } = require('commonsComponents/OKTableCell');
const OKTag = require('components/commons/OKTag/OKTag');
const OKTooltip = require('components/commons/OKTooltip/OKTooltip');

// @actions
const rightsActions = require('actions/rightsProfile');
const notification = require('actions/notifications');

// @utilities
const rightsProfileHelper = require('utilities/rightsProfileHelper');
const PersonalDataHelper = require('utilities/personalDataHelper');
const dateHelper = require('utilities/dateHelper');

// @constants
const {
    DATE_FORMAT_API,
    NOTIFIED_RIGHTS,
    ACCESS,
    PORTABILITY,
    ERROR_RIGHTS,
    EXPIRED_RIGHTS
} = require('constants/index');

const linkAccess = '/myprofile/rights/access';
const linkPortable = '/myprofile/rights/portability';

class RightsSelectorView extends React.Component {

    componentDidMount () {
        this.props.rightsActions.getRights(([ACCESS, PORTABILITY]))
    }

    handleGetKeyDownloadRights = rights => {
        this.props.rightsActions.getKeyDownloadRights(
            rights.reportId,
            rights.fileGdprZipOriginalCsvPath,
            rights.fileGdprZipOriginalJsonPath,
            rights.fileGdprReport,
            rights.type
        )
    };

    handleDownloadFile = fileRights => {
        this.props.rightsActions.downloadFile(fileRights);
    };

    // Build button to navigate to create new reports (access or portability)
    buildButtonLinkFooterTable(canBeRequested, type) {
        const classButton = canBeRequested ? '' : 'rights-selector-view__disabled-button';
        const url = type === ACCESS ? linkAccess : linkPortable;

        return (
            <div className="rights-selector-view__content-button">
                <OKLink modifier="emphasize" to={url} extraClass={classButton} >
                    <FormattedText value="rightsSelector-linkBox" />
                </OKLink>
            </div>
        );
    }

    // Build tooltip to show information and recovery file´s password
    buildContentTooltipModal = rights => {
        return (
            <div className="rights-selector-view__tooltip-table-container">
                <FormattedText value="rightsSelector-getNewKeyDescription" format="firstUppercase"/>{' '}
                <OKLink
                    modifier="widget"
                    onClick={() => this.handleGetKeyDownloadRights(rights)}
                >
                    <FormattedText value="rightsSelector-getNewKeyLink"/>
                </OKLink>
            </div>
        )
    };

    // build last link info text
    buildTextTerms () {

        return(
            <div className="col-md-12 grid-view--fix-cell-separation">
                <FormattedText value="rightsSelector-linkFooter" />
                &nbsp;
                <OKLink modifier="emphasize" to={formatText('dataProtectionLink-es')} target="_blank">
                    <FormattedText value="common-link" />
                </OKLink>.
            </div>
        )
    }

    buildRightsSelectorTable = rightsType => {
        const { immRightsProfile } = this.props;

        let rightsAccessTable = immRightsProfile.get('rights').map((rights, index) => {
            const type = rights.type
            const download = rights.status === NOTIFIED_RIGHTS;
            const rightsState = rightsProfileHelper.getRightsState(rights.status);
            const contentaTooltipDownload = this.buildContentTooltipModal(rights);
            const rightDate = moment(rights.requestDate);
            const email = rights.emailThirdParty ? rights.emailThirdParty : rights.emailNotif;
            const date = dateHelper.isToday(rightDate) ? formatText('rightsProfile-todayTableTerm') : rightDate.format(DATE_FORMAT_API);
            const fileRights = rights.fileGdprReport;
            let tagType;

            if ([ERROR_RIGHTS, EXPIRED_RIGHTS].includes(rights.status)) {
                tagType = 'warning'
            }

            if (rightsType === type) {
                return(
                    <OKTableRow asHeader={false} key={index.toString()}>
                        <OKTableCell
                            className="rights-selector-view__date-cell"
                        >
                            {date}
                        </OKTableCell>
                        <OKTableCell
                            className="rights-selector-view__email-cell"
                        >
                            {email}
                            <span>{rights.email}</span>
                        </OKTableCell>
                        <OKTableCell
                            className="rights-selector-view__state-cell"
                        >
                            <OKTag content={rightsState} context="arrow" type={tagType}/>
                        </OKTableCell>
                        <OKTableCell
                            className="rights-selector-view__download-cell"
                        >
                            {
                                download && <div>
                                    <span className="rights-selector-view__download-button" onClick={() => this.handleDownloadFile(fileRights)}>
                                        <FormattedText value="rightsSelector-linkDownload" format="firstUppercase"/>
                                    </span>
                                    <OKTooltip
                                        content={contentaTooltipDownload}
                                        offset={[0, -15]}
                                    />
                                </div>
                            }
                        </OKTableCell>
                    </OKTableRow>
                )
            }
        });

        return (
            <OKTable>
                <thead>
                    <OKTableRow asHeader={true}>
                        <OKTableCell
                            className="rights-selector-view__date-header-cell"
                            asHeader={true}
                        >
                            <FormattedText value="rightsProfile-dateHeaderCell" format="uppercase" />
                        </OKTableCell>
                        <OKTableCell
                            className="rights-selector-view__email-header-cell"
                            asHeader={true}
                        >
                            <FormattedText value="rightsSelector-emailHeaderCell" format="uppercase" />
                        </OKTableCell>
                        <OKTableCell
                            className="rights-selector-view__state-header-cell"
                            asHeader={true}
                        >
                            <FormattedText value="rightsProfile-stateHeaderCell" format="uppercase" />
                        </OKTableCell>
                        <OKTableCell asHeader={true} ></OKTableCell>
                    </OKTableRow>
                </thead>
                <tbody>
                    {rightsAccessTable}
                </tbody>
            </OKTable>
        )
    };

    buildAccessRightsSelector () {
        const { immProfileFields, immRightsProfile } = this.props;
        const email = PersonalDataHelper.getEmail(immProfileFields);

        const createTable = immRightsProfile.get('rights').length > 0
            ?
            lodash.find(immRightsProfile.get('rights'), o => o.type === ACCESS)
            :
            false;

        const table = createTable ? this.buildRightsSelectorTable(ACCESS) : null;
        const button = this.buildButtonLinkFooterTable(immRightsProfile.get('canBeRequestedAccessReport'), ACCESS);

        return(
            <div className="col-md-12">
                <OKSectionBox title={formatText('rightsSelector-accessTitle')}>
                    <div className="row">
                        <div className="col-xs-12 content-no-padding">
                            <p>
                                <FormattedText
                                    value="rightsSelector-accessDescriptionFirst"
                                    injectedStrings={[email]}
                                />
                            </p>
                            <p><FormattedText value="rightsSelector-accessDescriptionSecond" /></p>
                            <p><FormattedText value="rightsSelector-accessDescriptionThird" /></p>
                        </div>
                        <div className="col-xs-12 content-no-padding rights-selector-view__table-rights-access">
                            {table}
                        </div>
                        <div className="col-xs-12 content-no-padding last-cell">
                            {button}
                        </div>
                    </div>
                </OKSectionBox>
            </div>
        );
    }

    buildPortabilityRightsSelector () {
        const { immProfileFields, immRightsProfile } = this.props;
        const email = PersonalDataHelper.getEmail(immProfileFields);

        const createTable = immRightsProfile.get('rights').length > 0
            ?
            lodash.find(immRightsProfile.get('rights'), o => o.type === PORTABILITY)
            :
            false;

        const table = createTable ? this.buildRightsSelectorTable(PORTABILITY) : null;
        const button = this.buildButtonLinkFooterTable(immRightsProfile.get('canBeRequestedPortabilityReport'), PORTABILITY);

        return(
            <div className="col-md-12 grid-view--fix-cell-separation">
                <OKSectionBox title={formatText('rightsSelector-portableTitle')}>
                    <div className="row">
                        <div className="col-xs-12 content-no-padding">
                            <FormattedText value="rightsSelector-portableDescriptionFirst" injectedStrings={[email, email]}/>
                        </div>
                        <div className="col-xs-12 content-no-padding rights-selector-view__table-rights-access">
                            {table}
                        </div>
                        <div className="col-xs-12 content-no-padding last-cell">
                            {button}
                        </div>
                    </div>
                </OKSectionBox>
            </div>
        );
    }

    buildMappingBreadcrumb () {
      return [
          {
              text: formatText('breadcrumb-personalInformation'),
              url: '/myprofile/edit'
          },
          {
              text: formatText('breadcrumb-selectorRights'),
              url: ''
          }
      ];
    }

    render () {

        const { immProfileFields } = this.props;
        const email = PersonalDataHelper.getEmail(immProfileFields);
        const boxBody = ['rightsSelector-boxBody1', 'rightsSelector-boxBody2', 'rightsSelector-boxBody3'];
        const accessSelector = this.buildAccessRightsSelector();
        const portableSelector = this.buildPortabilityRightsSelector();
        const textTerms = this.buildTextTerms();

        return (
            <div>
                <div className="container-fluid">
                    <div className="row">
                        <OKCover size="medium" section="pg" customClass="col-xs-12">
                            <OKHeaderSubPage
                                breadcrumbConfig={this.buildMappingBreadcrumb()}
                                finalTitle={getFinalTitle('breadcrumb-selectorRights')}
                            />
                        </OKCover>
                    </div>
                </div>
                <div className="grid-view__body">
                    <div className="container-fluid">
                        <div className="row grid-view--content-position-negative rights-selector-view">
                            <div className="col-xs-12 col-md-8">
                                <div className="row">
                                    {accessSelector}
                                    {portableSelector}
                                    {textTerms}
                                </div>
                            </div>
                            <div className="col-xs-12 col-md-4">
                                <div className="row">
                                    <div className="col-xs-12 grid-view--variable-cell-separation">
                                        <ContactInfoBox
                                            boxTitle={formatText('rightsSelector-boxTitle')}
                                            boxBody={boxBody}
                                            injectedStrings={{
                                                'rightsSelector-boxBody3': [email]
                                            }}
                                        />
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}

RightsSelectorView.propTypes = {
    immRightsProfile: PropTypes.func,
    rightsActions: PropTypes.func,
    immProfileFields: PropTypes.func,
    originCountry: PropTypes.string
}

module.exports.constructor = RightsSelectorView;

module.exports.RightsSelectorView = connect(
    state => ({
        immRightsProfile: state.rightsProfile,
        immProfileFields: state.profile,
        originCountry: state.profile.get("originCountry")
    }),
    dispatch => ({
        rightsActions: bindActionCreators(rightsActions, dispatch),
        notification: bindActionCreators(notification, dispatch),

    })
)(RightsSelectorView);
